module.exports = __webpack_public_path__ + "img/product_06.ce288ab3.jpg";